import React, {useMemo} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import {withRouter} from "react-router-dom";

import {ROUTES} from "../../../../routes";
import {IS_DEALER_FLOW} from "../../../../config";


const GroheCartStepper = (props) => {

  const {history, location, fabricatorSettings, isPhoneNumberValidated, shippingAddress} = props;

  const allSteps = useMemo(() => {
    return [{
      translateId: "grohe.cart.stepper.information",
      isVisible: true,
      isDisabled: false,
      url: IS_DEALER_FLOW ? ROUTES.cart : ROUTES.cartLogin,
    }, {
      translateId: "grohe.cart.stepper.billing",
      isVisible: fabricatorSettings.hasPaymentGateway,
      isDisabled: !isPhoneNumberValidated,
      url: ROUTES.cartBilling,
    }, {
      translateId: "grohe.cart.stepper.shipping",
      isVisible: IS_DEALER_FLOW,
      isDisabled: !isPhoneNumberValidated,
      url: ROUTES.cartShipping,
    }, {
      translateId: "grohe.cart.stepper.confirm",
      isVisible: true,
      isDisabled: !isPhoneNumberValidated || (IS_DEALER_FLOW && !(shippingAddress.address1 && shippingAddress.city)),
      url: ROUTES.cartConfirm,
    }, {
      translateId: "grohe.cart.stepper.shipping",
      isVisible: fabricatorSettings.useShipping,
      isDisabled: !isPhoneNumberValidated,
      url: ROUTES.cartDelivery,
    }];
  }, [fabricatorSettings, isPhoneNumberValidated, shippingAddress])

  const setStep = (step) => {
    if (step.isDisabled) {
      return false
    }
    history.push(step.url);
  }

  return (
    <div className="gc-stepper">
      <ul className="gc-stepper__list">
        {allSteps.map((step, stepIndex) => {
          if (!step.isVisible) {
            return null
          }
          const isActive = step.url === ROUTES.cartLogin
            ? location.pathname === ROUTES.cartLogin || location.pathname === ROUTES.cartRegister
            : location.pathname === step.url;
          return (
            <li className={"gc-stepper__list-item" + (isActive ? " gc-stepper__list-item--active" : "")
              + (step.isDisabled ? " gc-stepper__list-item--disabled" : "")}
                key={step.translateId + stepIndex}
                onClick={() => setStep(step)}>
              <FormattedMessage id={step.translateId}/>
            </li>
          )
        })}
      </ul>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {settings} = store.fabricatorState;
  const {isPhoneNumberValidated} = store.userState;
  const {shippingAddress} = store.paymentState;

  return {
    isMobile,
    isPhoneNumberValidated,
    fabricatorSettings: settings,
    shippingAddress,
  };
};

const mapDispatchToProps = {
  // setLookPageOpened,
  // setLookOpened,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroheCartStepper)
)
